export const GIFT_CARD_CODE_PLACEHOLDER = '1234 5678 9100 0000'
export const GIFT_CARD_LENGTH = 16
export const GIFT_CARD_INPUT_MAX_LENGTH = 19

// Refactor and move to text constants for translation.
export const INVALID_GIFT_CARD_LENGTH = 'Please enter a valid gift card code.'
export const APPLY_GIFT_CARD = 'Apply'
export const GIFT_CARD_REDEEM_TEXT = 'Redeem a gift card'
export const GIFT_CARD_PROMPT_TEXT = 'HAVE A GIFT CARD?'
export const GIFT_CARD_ADDED = `Your gift card was applied to this order.`
export const GIFT_CARD_REMOVED = 'Your gift card was removed from this order.'
export const GIFT_CARD_CHECK_BALANCE_TEXT = 'Check balance'

export const GIFT_CARD_ERRORS = {
	invalidCode: 'Invalid gift card code.',
	doesNotExist: 'Gift card does not exist.',
	notAllowed: 'Gift card cannot be used for this order.',
}
